import { useEffect, useState } from 'react'
import { functional } from '@think-internet/zeus-frontend-package'
import Routes from '../../../redux/routes'
import { NAWSurvey } from '../../../types/NAW/Survey'

const useLoadPublicSurvey = (uuid: string): NAWSurvey => {
  const loadNAWSurvey = functional.use(Routes.LOAD_PUBLIC_NAW_SURVEY)
  const [survey, setSurvey] = useState<NAWSurvey>(null)

  useEffect(() => {
    const fetch = async () => {
      const survey = await loadNAWSurvey({ uuid })

      if (survey) {
        setSurvey(survey)
      }
    }
    if (!!uuid && (!survey || survey.uuid !== uuid)) fetch()
  }, [uuid, survey, loadNAWSurvey])

  return !!survey && survey.uuid === uuid ? survey : null
}

export default useLoadPublicSurvey
